import { render, staticRenderFns } from "./ITConsultingDetails.vue?vue&type=template&id=630f9874&"
import script from "./ITConsultingDetails.vue?vue&type=script&lang=js&"
export * from "./ITConsultingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports